import React from 'react';
import {
  Card,
  CardProps,
  CardContent,
  CardActionArea,
  Grid,
  Avatar,
  AvatarProps,
  Typography,
} from '@mui/material';
import { IQuestionDetailAnswer } from '../../../store/QuestionSlice';
import CustomGrayContainer from '../../../components/Containers/CustomGrayContainer';
import { getSubjectColor } from '../../../helper';

const avatarStyles: AvatarProps['sx'] = {
  width: '30px',
  height: '30px',
  color: 'text.primary',
  fontSize: '100%',
  fontWeight: 600,
};

export interface IAnswerListItem {
  answer: IQuestionDetailAnswer;
  showAnswer?: boolean;
  markingSchema?: string;
}

const AnswerListItem: React.FC<IAnswerListItem> = ({
  answer,
  showAnswer = false,
  markingSchema,
}) => {
  const _order = (answer.order + 1).toString().padStart(2, '0');

  let hightlightContainerStyles: CardProps['sx'] = {
    border: '1px solid #E1E1E1',
    borderRadius: '7px',
  };

  if (showAnswer && answer.isCorrect) {
    hightlightContainerStyles = {
      border: '2px solid',
      borderImageSlice: 1,
      borderImageSource: getSubjectColor(''),
    };
  }

  return (
    <Card style={{ boxShadow: 'unset' }}>
      <CardContent style={{ padding: '0' }}>
        <CardActionArea disabled>
          <CustomGrayContainer
            style={{ backgroundColor: 'white', padding: '10px 10px 5px 10px' }}
            sx={hightlightContainerStyles}
          >
            <Grid container spacing={1}>
              <Grid item xs={2} sm={2} style={{ maxWidth: '50px' }}>
                <Avatar sx={avatarStyles}>{_order}</Avatar>
              </Grid>
              <Grid item xs={10}>
                <div
                  className="view ql-editor ql-viewer"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: answer.content }}
                />
              </Grid>
              {showAnswer && answer.isCorrect && markingSchema && (
                <Grid item>
                  <div
                    style={{
                      maxHeight: '400px',
                      overflowY: 'auto',
                      display: 'flex',
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      style={{
                        paddingLeft: '50px',
                      }}
                    >
                      Marking scheme:
                    </Typography>
                    <div
                      className="view ql-editor ql-viewer"
                      style={{
                        paddingTop: '0',
                      }}
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: markingSchema,
                      }}
                    />
                  </div>
                </Grid>
              )}
            </Grid>
          </CustomGrayContainer>
        </CardActionArea>
      </CardContent>
    </Card>
  );
};

export default AnswerListItem;
